import React, { useState, useEffect, useRef } from 'react';
import { Download, Users, CheckCircle, Lightbulb } from 'lucide-react';
import { Link } from 'react-router-dom';

const Counter = ({ target, label, icon: Icon, isVisible }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000; // 2 seconds
    let start = 0;
    const end = target;
    const incrementTime = Math.max(1, duration / end); // Ensure incrementTime is at least 1ms

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) {
        clearInterval(timer);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [target, isVisible]);

  return (
    <div className="text-center">
      <Icon size={28} className="text-[#364A9A] mx-auto mb-2 sm:mb-3" />
      <p className="font-bold text-3xl sm:text-4xl text-[#364A9A] mb-1">{count}+</p>
      <p className="text-gray-700 text-base sm:text-lg font-serif">{label}</p>
    </div>
  );
};

const CompanyOverview = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const companyProfileUrl = `${process.env.REACT_APP_BASE_URL_API}/company_profile/Company Profile -MK Metal & Engineering works 2025.pdf`;
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false); // Reset for re-animation if scrolled out and back in
          // Optionally reset counts here if you want them to re-animate every time
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-16 px-4 bg-gray-50">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Column: Image */}
        <div className="lg:col-span-1">
          <img
            src="/hero_img/image-02.jpg" // Using one of the hero images as a placeholder
            alt="Company Overview"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Right Column: Content */}
        <div className="lg:col-span-1 flex flex-col justify-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#364A9A] mb-6 font-poppins leading-tight">
            Industry leader in providing complete construction solutions
          </h2>
          <div className="mb-8 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-0 justify-items-center">
            <Counter target={100} label="Employees" icon={Users} isVisible={isVisible} />
            <Counter target={300} label="Completed Projects" icon={CheckCircle} isVisible={isVisible} />
            <Counter target={150} label="Concept Developed" icon={Lightbulb} isVisible={isVisible} />
          </div>
          
          <Link to={companyProfileUrl}
           target="_blank" rel="noopener noreferrer" className="bg-[#364A9A] text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center w-fit">
            <Download size={20} className="mr-2" /> Download Profile
          </Link>

          {/* <a href="http://localhost:5000/company_profile/Company Profile -MK Metal & Engineering works 2025.pdf" target="_blank" rel="noopener noreferrer" download className="bg-[#364A9A] text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center w-fit">
            <Download size={20} className="mr-2" /> Download Profile
          </a> */}
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;
